// @flow

import React, { Component } from "react";

import ConfidenceButtons from "../ConfidenceButtons/ConfidenceButtons";
import ConfidenceLabels from "../ConfidenceLabels/ConfidenceLabels";

import type { Template } from "../../templates/";

import "./TaskResponseForm.css";

type State = {
  confidence: ?number
};

type Props = {
  submit: (response: { confidence: number }) => void,
  lostFocus: () => void,
  template: Template
};

class TaskResponseForm extends Component<Props, State> {
  interval: ?IntervalID;

  constructor(props: Props) {
    super(props);
    this.state = { confidence: null };
    this.interval = null;
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      if (!document.hasFocus()) {
        this.props.lostFocus();
      }
    }, 1000);
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  submitConfidence = (confidence: number) => {
    this.props.submit({ confidence });
    this.setState({ confidence: null });
  };

  render() {
    return (
      <div className="TaskResponseForm">
        <div className="TaskResponseForm-PromptText">
          {this.props.template.task.prompt}
        </div>
        <ConfidenceButtons
          submit={this.submitConfidence}
          selected={this.state.confidence}
        />
        <ConfidenceLabels template={this.props.template} />
      </div>
    );
  }
}

export default TaskResponseForm;



// WEBPACK FOOTER //
// ./src/components/TaskResponseForm/TaskResponseForm.js